module.exports = __webpack_public_path__ + "img/157.670f89d8.jpg";